(ns quuppa.qsm.permissions
  (:require [re-frame.core :as rf]
            [quuppa.qsm.subs :as qsm-subs]))

(defn is-qsm-owner? []
  (let [session-user @(rf/subscribe [::qsm-subs/user])
        user-role (first (:roles session-user))]
    (or
      (= user-role "owner")
      (= user-role "quuppa-support"))))

(defn is-quuppa-support? []
  (let [session-user @(rf/subscribe [::qsm-subs/user])
        user-role (first (:roles session-user))]
    (= user-role "quuppa-support")))

(defn is-qsm-admin? []
  (let [session-user @(rf/subscribe [::qsm-subs/user])
        user-role (first (:roles session-user))]
    (= user-role "admin")))

(defn is-qsm-member? []
  (let [session-user @(rf/subscribe [::qsm-subs/user])
        user-role (first (:roles session-user))]
    (= user-role "member")))

(defn user-in-qsm-domain? []
  (or (is-qsm-owner?)
      (is-qsm-admin?)
      (is-qsm-member?)))

(defn has-manage-permission? []
  (or (is-qsm-owner?)
      (is-qsm-admin?)))

(defn has-manage-permission-to-resource? [resource]
  (boolean (some #{(:resource-role resource)} ["owner" "admin"])))

(defn has-manage-permission-to-site?
  "Project level admin/owner confers the same rights on every site in that project,
  matching quuppa.qsm.user/has-manage-permissions-to-resource? on the backend."
  [site parent-project]
  (or (has-manage-permission-to-resource? site)
      (has-manage-permission-to-resource? parent-project)))
